export default __webpack_public_path__ + "static/media/image_house-topics.6569e7da.svg";